import Email from "./email.svg";
import Github from "./github.svg";
import Linkedin from "./linkedin.svg";
import Resume from "./resume.svg";
import ArrowLeft from "./arrowleft.svg";
import ArrowRight from "./arrowright.svg";
import LinkIcon from "./link.svg";
import Touch from "./touch.svg";
import Bucket from "./bucket.svg";
import Lighthouse from "./lighthouse.svg";

export {
    Email,
    Github,
    Lighthouse,
    Linkedin,
    Resume,
    ArrowLeft,
    ArrowRight,
    LinkIcon,
    Touch,
    Bucket,
};
